import dayjs from 'dayjs'
import './OrderLayout.css'
import './OrderResponsive.css'

const hasValue = value => value !== undefined && value !== null && String(value).trim() !== '' && value !== 'Отсутствует'

// Presentation only: fulfillment and its state remain owned by the calling page.
export function OrderLayout({ orders, kind = 'code', status = 'Получен', complete = true,
  image, title, extra, facts = [], dateLabel, dateValue, children, after }) {
  const labels = { random: 'Случайная игра Steam', random_tg_gift: 'Подарок подписчику',
    topUp: 'Пополнение Steam', mobileTopUp: 'Мобильная связь', code: 'Цифровой товар', account: 'Данные аккаунта',
    gift: 'Steam Gift', eSIM: 'Мобильный интернет', DTU: 'Игровое пополнение' }
  const date = orders?.receiptDate
  const formattedDate = date && dayjs(date).isValid() ? dayjs(date).format('DD.MM.YYYY HH:mm') : null
  const shownDate = dateValue ?? formattedDate
  const visibleFacts = facts.filter(fact => hasValue(fact.value))
  const hasExtra = hasValue(extra?.value)
  const extraOnly = !hasValue(shownDate) && visibleFacts.length === 0
  return <main className='redemption-page'>
    <div className='redemption-layout' data-product={kind} data-complete={complete}>
      <article className='order-card' aria-label='Ваша покупка'>
        <header className='order-card__bar'>
          <span className='order-card__brand'>PAY2PLAY</span>
          <span className='order-card__number'>{String(orders?.orderNumber || '').startsWith('manual-')
            ? 'manual' : `${kind === 'random_tg_gift' ? 'Подарок для' : 'Заказ №'} ${orders?.orderNumber || '—'}`}</span>
        </header>
        <div className='order-card__cover'>{image || <img src={orders?.image} alt={kind === 'eSIM' ? 'eSIM' : kind === 'DTU' ? 'DTU' : 'Gift Card'} />}</div>
        <div className='order-card__intro'>
          <div className='order-card__intro-top'>
            <span className='order-card__eyebrow'>{labels[kind] || labels.code}</span>
            <span className={`order-card__status${complete ? ' order-card__status--complete' : ''}`}><span aria-hidden='true'>●</span>{status}</span>
          </div>
          <h1 className='order-card__title'>{title || orders?.orderName || labels[kind] || labels.code}</h1>
        </div>
        {(!extraOnly || hasExtra) && <dl className='order-card__facts' data-extra-only={extraOnly}>
          {hasValue(shownDate) && <div><dt>{dateLabel || (complete ? 'Получено' : 'Дата заказа')}</dt><dd>{shownDate}</dd></div>}
          {hasExtra && <div className='order-card__extra'><dt>{extra.label}</dt><dd>{extra.value}</dd></div>}
          {visibleFacts.map(fact => <div key={fact.label}><dt>{fact.label}</dt><dd>{fact.value}</dd></div>)}
        </dl>}
        <div className='order-card__delivery'>{children}</div>
      </article>
      <div className='order-card__after'>{after}</div>
    </div>
  </main>
}
